/* eslint-disable @typescript-eslint/no-non-null-assertion */
type Resolve = () => void;
type Reject = (err: any) => void;

let pendingPromise: { resolve: Resolve; reject: Reject } | null = null;
let showFn: ((resolve: Resolve, reject: Reject) => void) | null = null;

export const registerMfaModal = (fn: typeof showFn) => {
    showFn = fn;
};

export const triggerMfaVerify = async (): Promise<void> => {
    if (pendingPromise) {
        await new Promise((resolve, reject) => {
            const prev = pendingPromise!;
            pendingPromise = {
                resolve: () => {
                    prev.resolve();
                    resolve();
                },
                reject: (e) => {
                    prev.reject(e);
                    reject(e);
                },
            };
        });
        return;
    }
    await new Promise((resolve, reject) => {
        pendingPromise = { resolve, reject };
        showFn?.(resolve, reject);
    });
};

export const resolveMfaVerify = () => {
    pendingPromise?.resolve();
    pendingPromise = null;
};

export const rejectMfaVerify = (err: any) => {
    pendingPromise?.reject(err);
    pendingPromise = null;
};
